// 1.Dependency
import {
    createRouter,
    createWebHistory,
    // createWebHashHistory,
} from "vue-router";
import { filter, flatten } from "lodash";
import User from "@2kog/pkg-common/utils/user.js";
import { updateDocumentTitle } from "@/utils/route-meta";

// 2.Routes
const files = require.context("./", true, /\.js$/);
const routesModules = files.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    const value = files(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});
import dashboard from "./dashboard/index.js";

export const constantRoutes = [
    {
        name: "index",
        path: "/",
        redirect: "/dashboard",
        beforeEnter: () => {
            if (User.isLogin()) {
                return "/dashboard";
            }
        },
    },
    ...flatten(
        filter(routesModules, (module) => {
            return module;
        })
    ),
    ...dashboard,
];

// 3.Build An Instance
const router = createRouter({
    // history: createWebHashHistory(), //hash
    history: createWebHistory(), //history api
    // base : '/rewrite root',
    routes: constantRoutes,
});

// 4.Global Guard
router.beforeEach((to, from, next) => {
    // Set Title
    updateDocumentTitle(to);
    // document.documentElement.classList.add("p-" + to.name);
    next();
});

export default router;
